import { useFormContext } from 'react-hook-form'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'
import InputMask from 'react-input-mask'

type PhoneFieldProps = {
    label: string
    name: string
    helpText?: string
    placeholder?: string
    disabled?: boolean
    className?: string
}

const baseInputClass =
    'w-full h-10 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50'

export default function PhoneField({
    label,
    name,
    helpText,
    placeholder = '(555) 555-5555',
    disabled,
    className,
}: PhoneFieldProps) {
    const form = useFormContext()
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    <FormLabel htmlFor={name}>{label}</FormLabel>
                    <FormControl>
                        <InputMask
                            id={name}
                            {...field}
                            mask='(999) 999-9999'
                            format='(###) ###-####'
                            maskChar={null}
                            autoComplete='tel'
                            disabled={disabled}
                            placeholder={placeholder}
                            onChange={(ev) => {
                                const value = ev.target.value.replace(/[^a-zA-Z0-9]/g, '')
                                field.onChange(value)
                            }}
                            className={className ? className : baseInputClass}
                        />
                    </FormControl>
                    {helpText && (
                        <p className='text-sm text-muted-foreground'>{helpText}</p>
                    )}
                    <FormMessage />
                </FormItem>
            )}
        />
    )
}


